export default __webpack_public_path__ + "static/media/Mark-2-Suit-06.11445708.jpg";